import { render, staticRenderFns } from "./NewLoading.vue?vue&type=template&id=4a517cc9&scoped=true&"
import script from "./NewLoading.vue?vue&type=script&lang=js&"
export * from "./NewLoading.vue?vue&type=script&lang=js&"
import style0 from "./NewLoading.vue?vue&type=style&index=0&id=4a517cc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a517cc9",
  null
  
)

export default component.exports